import { useState } from 'react';
import { useStore } from '../../data/store';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import { Instagram, Facebook } from 'lucide-react';
import { api } from '../../data/api';

export default function Newsletter() {
  const settings = useStore((s) => s.settings);
  const [email, setEmail] = useState('');
  const [msg, setMsg] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [ref, isVisible] = useScrollAnimation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setSubmitting(true);
    try {
      await api.public.subscribe(email);
      setMsg('Willkommen! Du bist jetzt angemeldet.');
      setEmail('');
    } catch (err) {
      setMsg(err.message || 'Fehler beim Anmelden.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section id="kontakt" className="bg-bg-primary relative overflow-hidden section-padding">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-accent-red/5 to-transparent pointer-events-none" />
      <div
        ref={ref}
        className={`max-w-[480px] mx-auto text-center relative z-10 transition-all duration-700 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        <h2 className="font-heading text-text-primary mb-6" style={{ fontSize: 'clamp(28px, 7vw, 56px)' }}>VERPASSE NICHTS</h2>
        <p className="font-body text-text-muted leading-relaxed text-base md:text-lg mb-8 md:mb-10">
          Lineup-Ankündigungen, Neuigkeiten und exklusive Updates — direkt in dein Postfach.
        </p>

        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 mb-8 w-full">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Deine E-Mail Adresse"
            required
            className="flex-1 bg-bg-card border border-divider px-4 text-text-primary font-body text-base placeholder:text-text-muted focus:outline-none focus:border-accent-red w-full"
            style={{ height: '52px' }}
          />
          <button type="submit" disabled={submitting} className="bg-accent-red text-white font-heading tracking-wider px-8 border-2 border-accent-red hover:bg-transparent hover:text-accent-red transition-all whitespace-nowrap w-full sm:w-auto disabled:opacity-50" style={{ height: '52px', fontSize: '16px' }}>
            {submitting ? 'ANMELDEN...' : 'JETZT ANMELDEN'}
          </button>
        </form>

        {msg && <p className="text-accent-red font-body text-sm mb-6">{msg}</p>}

        <p className="font-body text-text-muted text-xs mb-10">Kein Spam. Nur Rock. Abmeldung jederzeit möglich.</p>

        <div className="flex justify-center gap-4">
          {settings?.instagram && (
            <a href={settings.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="w-12 h-12 border-2 border-divider flex items-center justify-center text-text-muted hover:text-accent-red hover:border-accent-red transition-all">
              <Instagram size={22} />
            </a>
          )}
          {settings?.facebook && (
            <a href={settings.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="w-12 h-12 border-2 border-divider flex items-center justify-center text-text-muted hover:text-accent-red hover:border-accent-red transition-all">
              <Facebook size={22} />
            </a>
          )}
        </div>
      </div>

    </section>
  );
}
